var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBrandIsotype = function SvgBrandIsotype(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.654.683 8.17 3.516l6.207-.017L15.915.667l-6.26.016Z",
    fill: "#85F451"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.908 3.533.423 6.365l6.207-.017L8.17 3.516l-6.26.017Z",
    fill: "#56BC2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.298 5.67 7.813 8.501l6.207-.017 1.539-2.832-6.26.016Z",
    fill: "#85F451"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.552 8.518.067 11.351l6.207-.017 1.539-2.832-6.26.016Z",
    fill: "#56BC2F"
  })));
};
export { SvgBrandIsotype as ReactComponent };
export default __webpack_public_path__ + "cf4d166afb3ec4ec1f8fa66dfbd11c01.svg";